/** Create a module worker from the bundled bootstrap (resolved by the app bundler). */
export function createModuleWorker(): Worker {
  return new Worker(new URL('./worker/bootstrap.ts', import.meta.url), { type: 'module', name: 'vp-module' });
}
